interface SimpleFieldRowProps {
  label: string
  omitIfUndefined?: boolean
  value: React.ReactNode
}

export function SimpleFieldRow ({
  label,
  omitIfUndefined = false,
  value,
}: SimpleFieldRowProps) {
  if (omitIfUndefined && value === undefined) {
    return null
  }

  if (typeof value === 'boolean') {
    throw new Error('Rendering boolean values is ambiguous. Use formatBoolean().')
  }

  // NOTE: If value is an empty string, this renders the "none" text
  return (
    <div className='px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0'>
      <dt className='text-sm font-medium leading-6 text-gray-900'>{label}</dt>
      <dd className='mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 flex items-center'>
        {value || '(none)'}
      </dd>
    </div>
  )
}
